import React, {useState} from 'react';
import { Link } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faTrashAlt, faPencilAlt, faTimes, faCheck} from '@fortawesome/free-solid-svg-icons';

export default function CabIndex({cab, dcId, user, api}) {

  const [editMode, setEditMode] = useState(false);
  const [name, setName] = useState(cab.name);

  const setNameValue = (evt) => setName(evt.target.value);
  const editCab = () => setEditMode(true);
  const cancelEdits = () => {
    setName(cab.name);
    setEditMode(false);
  }
  const confirmEdits = (evt) => {
    evt.preventDefault();
    api.updateCab(cab.id, cab.cabId, {name: name});
    setEditMode(false);
  }
  const deleteCab = () => {
    let confirmed = window.confirm(`Delete Cab ${cab.cabId}: ${cab.name}?`)
    if(!confirmed) return;
    api.deleteCab(cab.id, cab.cabId);
  }
  
  if(editMode) {
    return <form key={`cab_${cab.id}`} className="Cab list-group-item" onSubmit={confirmEdits} >
      <span className="Cab-badge badge badge-primary">{cab.cabId}</span>
      <input className="form-control" type="text" value={name} onChange={setNameValue} />
      <button type="button" onClick={cancelEdits} className={`Outlet-menu btn btn-danger`}><FontAwesomeIcon className={`Outlet-icon`} icon={faTimes} title="Cancel" /></button>
      <button type="submit" className="Outlet-menu btn btn-success"><FontAwesomeIcon className="Outlet-icon" icon={faCheck} title="Confirm" /></button>
    </form>
  }

  return <div key={`cab_${cab.id}`} className="Cab list-group-item" onSubmit={confirmEdits} >
    <span className="Cab-badge badge badge-primary">{cab.cabId}</span>
    <Link className="Cab-name" to={"/datacentre/" + dcId + "/cab/" + cab.id}>{cab.name}</Link>
    {user.accessLevel >= 2 && <button type="button" onClick={editCab} className="Outlet-menu btn btn-secondary"><FontAwesomeIcon className="Outlet-icon" icon={faPencilAlt} title="Edit Cab" /></button>}
    {user.accessLevel >= 2 && <button type="button" onClick={deleteCab} className="Outlet-menu btn btn-danger"><FontAwesomeIcon className="Outlet-icon" icon={faTrashAlt} title="Delete" /></button>}
    </div>
}
